/**
 * @generated SignedSource<<08ac404280868bc08e8369c0a3e36df0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingsPanelHeader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DatePickerAgenda_viewer" | "EventFilters_viewer">;
  readonly " $fragmentType": "MeetingsPanelHeader_viewer";
};
export type MeetingsPanelHeader_viewer$key = {
  readonly " $data"?: MeetingsPanelHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingsPanelHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingsPanelHeader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventFilters_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatePickerAgenda_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f974a82879e54cbbb73d1fb7975361c7";

export default node;
